"use client";

import { useI18n } from "@/i18n";
import LoginForm from "@/views/login/login-form";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@repo/uikit";
import type React from "react";

export interface LoginDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function LoginDialog({ isOpen, onClose, onSuccess }: LoginDialogProps) {
  const { t } = useI18n();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        data-testid="login-dialog-content"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="sm:max-w-md"
      >
        <DialogTitle className="sr-only" data-i18n="auth.signInTitle">
          {t("auth.signInTitle")}
        </DialogTitle>
        <DialogDescription className="sr-only" data-i18n="auth.signInDescription">
          {t("auth.signInDescription")}
        </DialogDescription>
        <LoginForm
          showLogo={true}
          onSuccess={() => {
            onClose();
            if (onSuccess) onSuccess();
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
